import styles from "../styles/Home.module.css";
import UnitListings from "../../../components/UnitListings";
import Page from "../../../components/Page";
import * as firestore from "firebase/firestore";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { firestore as db } from "../../../firebase";

type ClassSettingsType = Record<
    string,
    {
        default_units: string;
        current_semester: number;
        secondary_class_type: number;
    }
>;
const defaultSettings: ClassSettingsType = {
    calc: {
        default_units: "units_calcone",
        current_semester: 1,
        secondary_class_type: 1,
    },
    lindisc: {
        default_units: "units_linear",
        current_semester: 1,
        secondary_class_type: 3,
    },
};

export default function Units() {
    const SemesterSwitcher = () => (
        <div
            style={{
                position: "absolute",
                top: -25,
                right: -25,
                zIndex: 10,
                display: "flex",
                gap: "0px",
                height: "40px",
            }}
        >
            {semesterTables.map((table, idx) => (
                <button
                    key={table}
                    onClick={() => setSelectedUnitsTable(table)}
                    style={{
                        backgroundColor:
                            selectedUnitsTable === table ? "#90caf9" : "#eee",
                        fontSize: ".8rem",
                        width: "75px",
                        height: "40px",
                        borderRadius:
                            idx === 0 ? "0px 0px 0px 10px" : "0px 10px 0px 0px",
                        borderTop: "none",
                        // boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                        // border: "1px solid #bbb",
                        border: "none",
                        cursor:
                            selectedUnitsTable === table
                                ? "default"
                                : "pointer",
                        // marginRight: idx === 0 ? "2px" : "0px",
                        // marginLeft: idx === 1 ? "2px" : "0px",
                        marginTop: "0px",
                        marginBottom: "0px",
                    }}
                    disabled={selectedUnitsTable === table}
                >
                    {semesterLabels[idx]}
                </button>
            ))}
        </div>
    );

    const rawPage: string = window.location.pathname.split("/")[1];
    const page: string =
        rawPage === "math150"
            ? "calc"
            : rawPage === "math254"
            ? "lindisc"
            : "calc";

    // Semester tables for each class
    const semesterTables =
        page === "calc"
            ? ["units_calcone", "units_calc"]
            : ["units_linear", "units_lindisc"];

    const [defaultUnits, setDefaultUnits] = useState<string>(
        defaultSettings[page].default_units
    );
    const [selectedUnitsTable, setSelectedUnitsTable] = useState<string>(
        defaultSettings[page].default_units
    );

    useEffect(() => {
        document.title = "Math With Maki | Units";
        // Fetch default_units from class_settings
        const settingsRef = firestore.doc(db, "class_settings", page);
        firestore.getDoc(settingsRef).then((doc) => {
            if (doc.exists()) {
                const data = doc.data();
                setDefaultUnits(
                    data.default_units || defaultSettings[page].default_units
                );
                setSelectedUnitsTable(
                    data.default_units || defaultSettings[page].default_units
                );
            }
        });
    }, [page]);

    // Button labels
    const semesterLabels = ["Semester 1", "Semester 2"];

    const unitsRef = firestore.collection(db, selectedUnitsTable);
    const query = firestore.query(
        unitsRef,
        firestore.orderBy("order"),
        firestore.limit(999)
    );
    const [units_raw] = useCollection(query);

    const data: UnitList =
        units_raw?.docs.map((x) => {
            let lessons = x.data().lessons;
            lessons = lessons.sort((a: Lesson, b: Lesson) => {
                return a.order - b.order;
            });
            return {
                name: x.data().name,
                order: x.data().order,
                lessons: lessons,
                id: x.id,
                ...x.data(),
            };
        }) || [];

    return (
        <>
            <head>
                <title>Math with Maki</title>
                <meta name="description" content="Math with Maki" />
                <link rel="icon" href="/favicon.ico" />
            </head>
            <Page href={rawPage} style={{ position: "relative", width: "100%", height: "100%" }}>
                <SemesterSwitcher></SemesterSwitcher>
                <UnitListings
                    path={rawPage}
                    units={data}
                    semester={selectedUnitsTable}
                    semesterSwitcher={<></>}
                />
            </Page>
        </>
    );
}
